import Icon from '@mui/icons-material/AspectRatio';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function AspectRatioIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
